import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./redux";
import {
  setConnectionStatus,
  setNetworkStatus,
} from "../redux/Network/network.slice";
import type { ITimeProvider } from "../hexagon/adapters/driven/providers/provider";
import type { IAnalyticsController } from "../hexagon/adapters/driver/analyticsController";
import { IlocalStorageProvider } from "../hexagon/adapters/driven/providers/localStorageProvider";

interface IUseNetworkStatus {
  analyticsController: IAnalyticsController;
  timeProvider: ITimeProvider;
  localStorageProvider: IlocalStorageProvider;
}

export const useNetworkStatus = ({
  analyticsController,
  timeProvider,
  localStorageProvider,
}: IUseNetworkStatus) => {
  const { connectionStatus, hsIsActive } = useAppSelector((state) => ({
    connectionStatus: state.network.connectionStatus,
    hsIsActive: state.healthScribe?.isActive,
  }));

  const dispatch = useAppDispatch();

  const goOnline = () => {
    const email = localStorageProvider.get("userEmail");

    if (email) {
      analyticsController.identify(email);
    }

    // analyticsController.logEvent("Connectivity", {
    //   email: email || "-",
    //   lastOnlineTimestamp: lastOnline?.timestamp || "-",
    //   lastOnline: lastOnline?.current_time || "-",
    //   selectedFacility: userClinic?.name || "-",
    // });

    setTimeout(() => {
      dispatch(setNetworkStatus({ connectionStatus: true, lastOnline: null }));

      // IMPORTANT: Avoid auto-reloading when the HealthScribe recording UI is active.
      // A full page reload during an active audio recording/transcription would cause data loss.
      const preventReloadDueToActiveRecording = !!hsIsActive;
      if (!preventReloadDueToActiveRecording) {
        window.location.reload();
      }
    }, 500); // delaying to show network bar
  };

  const goOffline = () => {
    const time = timeProvider.getDateTime();

    // store state here
    dispatch(
      setNetworkStatus({
        connectionStatus: false,
        lastOnline: { current_time: time.format(), timestamp: time.unix() },
      })
    );
  };

  useEffect(() => {
    dispatch(setConnectionStatus(navigator.onLine));

    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);

    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, [dispatch, goOffline, goOnline]);

  return connectionStatus;
};
